<template>
  <div class="lense-image">
    <LenseSVG ref="svg"/>
  </div>
</template>

<script>
import LenseSVG from "@/assets/lense.svg"

export default {
  name: "LenseImage",
  components: {
    LenseSVG
  },
  props: {
    startPerc: Number,
    endPerc: Number,
    innerZoomStart: Number,
    innerZoomEnd: Number,
    outerZoomStart: Number,
    outerZoomEnd: Number,
    innerRotationStart: Number,
    innerRotationEnd: Number,
    outerRotationStart: Number,
    outerRotationEnd: Number,
  },
  mounted: function() {
    if ("IntersectionObserver" in window) {
      const svg = this.$refs.svg
      const inner = svg.getElementsByClassName("inner")[0]
      const outer = svg.getElementsByClassName("outer")[0]
      const outerHighlight = svg.getElementsByClassName("outer-highlight")[0]

      const startPerc = parseFloat(this.startPerc) || 0.2
      const endPerc = this.endPerc || 0.8

      const innerZoomStart = this.innerZoomStart || 0.7
      const innerZoomEnd = this.innerZoomEnd || 1.1
      const outerZoomStart = this.outerZoomStart || 0.95
      const outerZoomEnd = this.outerZoomEnd || 1.05

      const innerRotationStart = this.innerRotationStart || 0
      const innerRotationEnd = this.innerRotationEnd || 315
      const outerRotationStart = this.outerRotationStart || 0
      const outerRotationEnd = this.outerRotationEnd || -90

      const animateLenses = () => {
        // use mid point of rect as scroll indicator
        const rectHeight = svg.getBoundingClientRect().height
        const rectMidPoint = svg.getBoundingClientRect().top + (rectHeight / 2)

        const scrollPerc = 1 - ((rectMidPoint + rectHeight / 2) / (window.innerHeight + rectHeight))

        let innerZoom = innerZoomStart
        let outerZoom = outerZoomStart
        let innerRotation = innerRotationStart
        let outerRotation = outerRotationStart

        if (scrollPerc > endPerc) {
          innerZoom = innerZoomEnd
          outerZoom = outerZoomEnd
          innerRotation = innerRotationEnd
          outerRotation = outerRotationEnd
        } else if (scrollPerc <= endPerc && scrollPerc >= startPerc) {
          // normalise the scroll percentage, taking into account boundaries
          const m = (scrollPerc - startPerc) / (endPerc - startPerc)

          innerZoom = innerZoomStart + (innerZoomEnd - innerZoomStart) * m
          outerZoom = outerZoomStart + (outerZoomEnd - outerZoomStart) * m
          innerRotation = innerRotationStart + (innerRotationEnd - innerRotationStart) * m
          outerRotation = outerRotationStart + (outerRotationEnd - outerRotationStart) * m
        }

        inner.setAttribute("style", `transform: rotate(${innerRotation}deg) scale(${innerZoom})`)
        outerHighlight.setAttribute("style", `transform: scale(${innerZoom * 1.1})`)
        outer.setAttribute("style", `transform: rotate(${outerRotation}deg) scale(${outerZoom})`)
      }

      // Force position incase of refresh
      animateLenses()

      this.observer = new IntersectionObserver(
        (entries) => {
          animateLenses()
          // Scroll listener is expensive, so be agressive with the cleanup
          removeEventListener("scroll", animateLenses)
          if (entries[0].isIntersecting) {
            addEventListener("scroll", animateLenses)
          }
        },
        {threshold: 0}
      );

      this.observer.observe(this.$el);
    }
  },
}
</script>

<style lang="scss" scoped>
  .lense-image {
    * {
      transform-origin: 50% 50%;
      transition: none;
      // https://stackoverflow.com/questions/46971640/how-to-fix-broken-transform-origin-on-ios11-and-macos10-12-safari
      // fix for rotating SVGs on iOS 11 and macOS 10.12
      transform-box: fill-box;
    }
  }
</style>
